import React, { Component } from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';  
import 'react-toastify/dist/ReactToastify.css';  
import arrow from './arrows.png';
import Switch from "react-switch";
import { MDBContainer, MDBInput } from "mdbreact";
import { trackPromise } from 'react-promise-tracker';

export default class FilesUploadComponent extends Component {

    constructor(props) {
        toast.configure() 
        super(props);
        this.onFileChange1 = this.onFileChange1.bind(this);
        this.onFileChange2 = this.onFileChange2.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmit1 = this.onSubmit1.bind(this);
        this.onSubmit2 = this.onSubmit2.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onClick1 = this.onClick1.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            imgCollection1: '',
            imgCollection2:'',
            view:0,
            visible_form1:false,
            visible_form2:false,
            checked:false,
            switch_act:false,
            radio:1
        }
    }
    
    onClick = nr => () => {
        this.setState({
          radio: nr
        });
      }
    

    onFileChange1(e) {
        if(e.target.files.length===2){
        this.setState({ imgCollection1: e.target.files,
            view:1,
            preview1: URL.createObjectURL(e.target.files[0]),
            preview2: URL.createObjectURL(e.target.files[1]),
            switch_act:true })
        }    
        else{toast('Please load two images');
             setTimeout(() => {window.location.reload(false)}, 4000);
             }
    }

    onFileChange2(e) {
        if(e.target.files.length===1){
        this.setState({ imgCollection1: e.target.files,
            view:1,
            preview1: URL.createObjectURL(e.target.files[0]),
                            switch_act:true })
        }    
        else{toast('Please load a single image');
             setTimeout(() => {window.location.reload(false)}, 4000);
             }
    }

    onSubmit(e) {
        e.preventDefault()
        var formData = new FormData();
        for (const key of Object.keys(this.state.imgCollection1)) {
            formData.append('imgCollection', this.state.imgCollection1[key])
        }
        trackPromise(
        axios.post("http://snf-873139.vm.okeanos.grnet.gr:5200/api/test", formData, {
        }).then(res => {
            this.setState({
                trans_im: res.data.img,
                scaleX:res.data.scaleX,
                scaleY:res.data.scaleY,
                translationX:res.data.translationX,
                translationY:res.data.translationY,
                angle:res.data.angle
            });
            console.log(res.data)
            this.messagesEnd.scrollIntoView({ behavior: "smooth" }); 
        }))
    }

    handleChange(checked) {
        this.setState({ checked:checked,
        visible_form1:checked,
        visible_form2:checked});}

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
      }
      
      componentDidMount() {
        this.scrollToBottom();
      }
      
      componentDidUpdate() {
        this.scrollToBottom();
      }

    onClick1(e) {
        e.preventDefault()
        const imgCollectionArr=Array.from(this.state.imgCollection1)
        let temp = imgCollectionArr[1]
        imgCollectionArr[1]=imgCollectionArr[0]
        imgCollectionArr[0]=temp
         this.setState({
                preview1: URL.createObjectURL(imgCollectionArr[0]),
                preview2: URL.createObjectURL(imgCollectionArr[1]), 
                imgCollection1: imgCollectionArr
            });
        }

        onSubmit1(e) {
            e.preventDefault()
            var formData = new FormData();
            for (const key of Object.keys(this.state.imgCollection1)) {
                formData.append('imgCollection', this.state.imgCollection1[key])
            }
            trackPromise(
            axios.post("http://snf-873139.vm.okeanos.grnet.gr:5200/api/test"+this.state.radio, formData, {
                }).then(res => {
                this.setState({
                trans_im: res.data.img
                });
                this.messagesEnd.scrollIntoView({ behavior: "smooth" }); 
        }))
        }
    

    onSubmit2(e) {
        e.preventDefault()
        setTimeout(() => {window.location.reload(false)}, 1000); 
    }



    render() {
        return (
            <div>
                <div className='row_s'><h3>Automated tool for dermoscopy images</h3></div>
                <div className='row_s'>
                    <form id='form1' hidden={this.state.visible_form1} onSubmit={this.onSubmit}>
                        <div class="form-group">
                            <input type="file" name="imgCollection1" hidden={this.state.trans_im} onChange={this.onFileChange1} multiple/>
                        </div>
                        <div hidden={this.state.trans_im} className="img_div">
                        <div id='main'>
                        <div className='s_container'>
                        <h3>Inputs</h3>
                        </div>
                         <div class='container'>   
                         <h5>Original Image</h5>
                        <img hidden={this.state.trans_im} src={this.state.preview1}/>
                        </div>
                        <div id='arrow_button'>
                            <input type="image" src={arrow} value='Exchange images' alt="reverse button" onClick={this.onClick1}/>
                        </div>
                        <div className='container'>
                        <h5>Follow Up Image</h5>
                        <img hidden={this.state.trans_im} alt='' src={this.state.preview2}/>
                        </div>
                        </div>
                        <div className="form-group">
                            <button className="btn btn-primary" type="submit" >Upload</button>
                        </div>
                        </div>
                        </form>
                        <form id='form2' hidden={!this.state.visible_form2} onSubmit={this.onSubmit1}>
                        <div className="form-group">
                            <input type="file" name="imgCollection2" hidden={this.state.trans_im} onChange={this.onFileChange2} multiple/>
                        </div>
                        <div hidden={this.state.trans_im} className="img_div">
                        <div id='main'>
                        <div class='s_container'> 
                        <h3>Inputs</h3>
                        </div>
                         <div className='container'>
                         <h5>Original Image</h5>
                        <img hidden={this.state.trans_im}  src={this.state.preview1}/>
                        </div>
                        <div className='container'>
                         <h5>Set Algorithm</h5>
                         <MDBContainer className="mt-1">
                            <MDBInput onClick={this.onClick(1)} checked={this.state.radio===1 ? true : false} label="B hat" type="radio"
                                id="radio1" />
                            <MDBInput onClick={this.onClick(2)} checked={this.state.radio===2 ? true : false} label="Lplcian" type="radio"
                                id="radio2" />
                            <MDBInput onClick={this.onClick(3)} checked={this.state.radio===3 ? true : false} label="Log" type="radio"
                             id="radio3" />
                            <MDBInput onClick={this.onClick(4)} checked={this.state.radio===4 ? true : false} label="L Sob " type="radio"
                             id="radio4" />
                             <MDBInput onClick={this.onClick(5)} checked={this.state.radio===5 ? true : false} label="Lls" type="radio"
                             id="radio5" />
                        </MDBContainer>     
                        </div>
                        </div>
                        <div className="form-group">
                            <button className="btn btn-primary" type="submit" >Upload</button>
                        </div>
                        </div>
                        </form>
                        <form  onSubmit={this.onSubmit2} hidden={this.state.visible_form1}>
                        <div hidden={!this.state.trans_im} className="img_div">
                        <div id='main'>
                        <div className='s_container'>
                        <h3>Inputs</h3>
                        </div>
                        <div className='container'>
                         <h5>Original Image</h5>
                        <img hidden={!this.state.trans_im} src={this.state.preview1} />
                        </div>
                         <div className='container'>
                         <h5>Follow Up Image</h5>
                        <img hidden={!this.state.trans_im}  src={this.state.preview2} />
                        </div>
                        </div>
                        </div>
                        <div hidden={!this.state.trans_im} className="img_div">
                        <div id='main'>
                        <div className='s_container'>
                        <h3>Outputs</h3>
                        </div>
                        <div className='container'>
                        <h5>Original Image</h5>
                        <img className='unique' hidden={!this.state.trans_im} src={this.state.preview1} />
                        </div>
                        <div className='container'>
                        <h5>Registered Image</h5>
                        <img hidden={!this.state.trans_im} src={`data:image/bmp;base64,${this.state.trans_im}` }  />
                        </div>
                        </div>
                            <div className='container'>
                                <h3 hidden={!this.state.trans_im} ><strong>Details
                                 <hr/>
                                <h4>Scale in XX' axis: {this.state.scaleX}</h4>
                                    <h4>Scale in YY' axis: {this.state.scaleY}</h4>
                                    <h4>Translation in XX' axis: {this.state.translationX}</h4>
                                    <h4>Translation in YY' axis: {this.state.translationY}</h4>
                                    <h4>Rotation Angle: {this.state.angle}</h4>
                                </strong></h3>
                            </div>
                            <hr/>
                        <div className="form-group">
                            <button className="btn btn-primary" type="submit" >Try Again</button>
                        </div>
                        </div>
                        </form>
                        <form  onSubmit={this.onSubmit2} hidden={!this.state.visible_form2}>
                        <div hidden={!this.state.trans_im} className="img_div">
                        <div id='main'>
                        <div className='s_container'>
                        <h3>Inputs</h3>
                        </div>
                        <div className='container'>
                         <h4>Original Image</h4>
                        <img hidden={!this.state.trans_im} src={this.state.preview1} />
                        </div>
                        </div>
                        </div>
                        <div hidden={!this.state.trans_im} className="img_div">
                        <div id='main'>
                        <div className='s_container'>
                        <h3>Outputs</h3>
                        </div>
                        <div className='container'>
                        <h4>Shaved Image</h4>
                        <img hidden={!this.state.trans_im} src={`data:image/bmp;base64,${this.state.trans_im}` }  />
                        </div>
                        <div id='second'>
                        <h4>Blended Image</h4>
                        <img className='unique' hidden={!this.state.trans_im} src={this.state.preview1} />
                        <img className='overlay' hidden={!this.state.trans_im}  src={`data:image/bmp;base64,${this.state.trans_im}` } />
                        </div>
                        </div>
                        <div className="form-group">
                            <button className="btn btn-primary" type="submit" >Try Again</button>
                        </div>
                        </div>
                        </form>
                </div>
                    <div id='horizontal'>
                        <div id='left'><h3>Registration</h3></div>
                        <div id='right'><h3>Hair removal</h3></div>
                        <div id='center'><Switch disabled={this.state.switch_act} onChange={this.handleChange} checked={this.state.checked} /></div>
                    </div>
                <div style={{ float:"left", clear: "both" }}
                    ref={(el) => { this.messagesEnd = el; }}>
                </div>
            </div>
        )
    }
}
